import React, { useState, useEffect } from 'react'
import SlideOver from '../SlideOver'
import NavBarRight from './NavBarRight'
import SlideOverContent from './SlideOverContent'
import CNLogo from '../CNLogo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faSearch } from '@fortawesome/free-solid-svg-icons';
import { getSearchResults, getSearchResultsForDropdown } from '../../redux/actions/search'
import { useDispatch, useSelector } from 'react-redux';
import CoursesDropdownV2 from './CoursesDropdownV2';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom'
import { useDebounce } from '../../hooks/useDebounce'
import SearchResultsDropdown from './SearchResultsDropdown'
import AdBanner from './AdBanner';
import SevenDayTrial from './7dayTrail/SevenDayTrial'
import { getEpsFormData } from '../../redux/actions/jobEligibilityScore'
import { setEpsData } from '../../redux/actions/userActivity'
import { validPaths } from '../../common/constants'

const settings = {
    dots: false,
    slidesToShow: 9,
    rows: 1,
    speed: 300,
    infinite: false,
    cssEase: "linear",
    adaptiveHeight: true,
};


const Navbar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isSlideOver, setSlideOver] = useState(false)
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [searchLoader, setSearchLoader] = useState(false);
    const [dropdownResults, setDropdownResult] = useState("");
    const [inputFocus, setInputFocus] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [isMegaMenu, setIsMegaMenu] = useState(true);
    const [searchBtn, setSearchBtn] = useState(false);
    const [noSearch , setNoSearch] = useState("");

    const isUserTokenPresent = useSelector(store => store?.authentication?.user_token ? true : false);
    const email = useSelector(store => store?.profileDetails?.email);
    const userId = useSelector(store => store?.profileDetails?.id);
    const subscription_type = useSelector(store=> store?.userSubscription?.subscription_type);
    const countDownDate = useSelector(store=> store?.userSubscription?.current_subscription_expires_at);
    const all_courses = useSelector(store => store?.courses?.allCourses)
    const isDarkOverlay = useSelector((store)=> store?.appTheme?.blackOverlay);
    const role_type = useSelector((store) => store?.userSubscription?.role_type);
    let location = useLocation();

    const profile_image = useSelector(
        (store) => store?.profileDetails?.profile_image
      );

    const handleSearch = (e) => {
        if (e.key === "Enter" && searchString !== "") {
            setSearchLoader(true);
            dispatch(getSearchResults(searchString, userId, res => {
                if (res) setSearchLoader(false);
                navigate('/search', { replace: true });
                console.log('invoke1');
                setNoSearch(searchString)
                setSearchString("")
                setDropdownResult(null);
            }));
        }
        
    }

    const handleSearchClick = (e) => {
        setSearchLoader(true);
        
        dispatch(getSearchResults(searchString, userId, res => {
            if (res) setSearchLoader(false);
            navigate('/search', { replace: true });
            console.log('invoke2');
            setNoSearch(searchString)
            setSearchString("")
        }));
    }

    useEffect(() => {
            setAllCourses(all_courses);
    }, [])

    useEffect(() => {
        if (location?.pathname?.includes('-courses')) setIsMegaMenu(false)
        else setIsMegaMenu(true)

        //dispatch(getEpsFormData(userId, successObj => dispatch(setEpsData(successObj))));

    }, [location])

    useEffect(() => {
        setUserLoggedIn(isUserTokenPresent)
    }, [isUserTokenPresent])

    // const handleInputChange = useDebounce((e) => {
    //     if (e.target.value === "") {
    //         setDropdownResult(null)
    //         return;
    //     }
    //     setSearchString(e.target.value);
    //     dispatch(getSearchResultsForDropdown(e.target.value, (res) => {
    //         setDropdownResult(res);
    //     }));
    // }, 300);

    const debouncedSearchValue = useDebounce(searchString, 500)

    useEffect(()=>{
        if (debouncedSearchValue){
        dispatch(getSearchResultsForDropdown(debouncedSearchValue, (res)=>{
            setDropdownResult(res)
        }))}
        else{
            setDropdownResult(null);
        }
    },[debouncedSearchValue])



    return (
        <>
            {location.pathname !== '/pricing' && location.pathname !== '/verification' &&  !location.pathname.includes('/verify/certificate') && location.pathname !== '/knowledge-graph' && location.pathname !== '/onboarding' && location.pathname !== '/onboarding/loader' && location.pathname !== '/set-password' && location.pathname !== '/' && location.pathname !== '/hackathon' && location.pathname !== '/knowledge-graph' && location.pathname !== '/onboarding' && location.pathname !== '/onboarding/loader' && !validPaths.includes(location.pathname) && location.pathname !== '/onboarding/analysis' && location.pathname !== '/halloffame/' && !location.pathname.includes('/halloffame/') && location.pathname !== '/recruiter' && location.pathname !== '/recruiter/' && location.pathname !== '/recruiter/results' && location.pathname !== '/recruiter/profile' && location.pathname !== '/recruiter/signup' && location.pathname !== '/leaderboard' && <div className="sticky top-0 z-10 h-fit bg-white backdrop-filter bg-opacity-100 shadow-2xl">
                {location.pathname !== '/pricing' &&  <AdBanner />}
                <div>
                    <SlideOver open={isSlideOver} setOpen={setSlideOver} title={email} scroll={true}  >
                        <SlideOverContent 
                            isUserLoggedIn={userLoggedIn} 
                            open={isSlideOver} 
                            setOpen={setSlideOver} 
                        />
                    </SlideOver>
                    <div className="flex justify-between mx-1 md:px-2 md:relative md:items-center md:justify-around h-14 md:h-16">
                        <div className="inline-flex gap-1">
                          
                            <FontAwesomeIcon onClick={(e) => setSlideOver(true)} icon={faBars} size="xl" className="ml-1 self-center block md:hidden text-gray-700 cursor-pointer" />
                            <a className='self-center ' href="/"><div className={`w-fit   flex items-center  rounded-md p-2 ml-1 md:ml-0 md:p-2 gap-2`}  style={{
        background: (role_type!=='basic'&& role_type!==undefined) ? 'linear-gradient(97.28deg, #FEED7F 0%, #CC8C04 100%)':'bg-white/10',
      }}>
                                <img src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager" alt=""  className='h-6 w-6 md:h-10 md:w-10'/>
                                <p className='text-xs font-medium md:text-lg hidden md:flex text-black'>LearnTube.ai</p>
                            </div></a>
                            {/* <a className='self-center ' href="/"><CNLogo textColor="black" isNavbar={true} type='nav' /></a> */}
                            {subscription_type === "trial" && <SevenDayTrial countDownDate={countDownDate}/>}
                        </div>
                        <div className="font-bold md:cursor-pointer hidden md:block">
                            <CoursesDropdownV2 />
                        </div>
                        <div className="hidden md:flex md:relative md:px-4 md:w-3/6 md:gap-5 drop-shadow-md z-50">
                            <input
                                type="text"
                                className="flex-auto lg:w-64 sm:w-42 lg:pl-4 h-10 rounded-md focus:shadow-md focus:border-10 focus:border-black focus:outline-none border border-solid border-gray-400 text-gray-800"
                                value={searchString}
                                onKeyPress={handleSearch}
                                onChange={(e) => {setSearchString(e.target.value); setNoSearch(e.target.value)}}
                                onFocus={(e) => setInputFocus(true)}
                                onBlur={(e) => {
                                    setTimeout(() => {
                                        setInputFocus(false)
                                    }, 650);
                                }}
                                placeholder="Search for something you want to learn e.g. design">
                            </input>
                            {dropdownResults && inputFocus && <SearchResultsDropdown results={dropdownResults} setSearchString={setSearchString} isEmpty={dropdownResults?.results !== "empty" ? false : true} noSearch={noSearch}/>}
                            {
                                !searchLoader ?
                                    <FontAwesomeIcon onClick={handleSearchClick} icon={faSearch} className="absolute active:text-teal-600 transform active:scale-75 right-8 pt-2.5 text-gray-500 cursor-pointer" size="lg" />
                                    :
                                    <FontAwesomeIcon className='animate-spin mt-3 text-teal-600' size='lg' icon={faCircleNotch} />
                            }
                        </div>
                        {/* <DynamicChecklist /> */}
                        <NavBarRight userLoggedIn={userLoggedIn} setSlideOver={setSlideOver} setSearchBtn={setSearchBtn} searchBtn={searchBtn} />
                    </div >

                    {/* Courses Horizontal Bar on Desktop */}
                    {/* I have cut and paste it in notepad whenever required paste the code */}
                    <div className={`${searchBtn ? 'flex md:hidden' : 'hidden'} relative p-2 z-50 -mt-1 drop-shadow-md bg-gradient-to-r from-teal-500 to-white`}>
                        <input
                            type="text"
                            className="flex-auto w-42 h-8 rounded-md focus:shadow-lg focus:border-15 focus:border-black focus:outline-none border-2 border-solid border-gray-400 text-xs text-gray-800 z-50"
                            onKeyPress={handleSearch}
                            onChange={(e) =>{ setSearchString(e.target.value); setNoSearch(e.target.value); }}
                            onFocus={(e) => setInputFocus(true)}
                            onBlur={(e) => {
                                setTimeout(() => {
                                    setInputFocus(false)
                                }, 650);
                            }}
                            placeholder="Search for something you want to learn e.g. design">
                        </input>
                        {dropdownResults && inputFocus && <SearchResultsDropdown results={dropdownResults} isEmpty={dropdownResults?.results !== "empty" ? false : true} noSearch={noSearch}/>}

                        {
                            !searchLoader ?
                                <FontAwesomeIcon onClick={handleSearchClick} icon={faSearch} className="absolute right-5 pt-2.5 text-gray-500 cursor-pointer z-50" size="sm" />
                                :
                                <FontAwesomeIcon className='animate-spin mt-3 text-teal-600 z-50' size='lg' icon={faCircleNotch} />
                        }
                    </div>
                </div>
            </div >}
        </>
    )
}

export default Navbar
